module.exports = __webpack_public_path__ + "static/media/Selfie-X-02.4f2b70b3.png";